export default __webpack_public_path__ + "static/media/ido-logo.2cdd3cf3.svg";